import React from 'react';

const AgentsListSortElement = (props) => {
  let icon = 'glyphicon-sort';
  let sOrder = 'ASC';
  let opacity = 1;
  if(props.sortOrder === 'ASC' && props.sortBy === props.columnName) {
    icon = 'glyphicon-sort-by-attributes';
    sOrder = "DESC"
  }
  if(props.sortOrder === 'DESC' && props.sortBy === props.columnName) {
    icon = 'glyphicon-sort-by-attributes-alt';
    sOrder = "ASC"
  }
  if(props.sortBy !== props.columnName) {
    icon = 'glyphicon-sort';
    sOrder = 'ASC';
    opacity = 0.2
  }
  return  (
    <span style={{float:'right', cursor: 'pointer', opacity: opacity}} className={"glyphicon " + icon}
          aria-hidden="true"
          onClick={() => props.sortAgentsList({
            sortBy: props.columnName,
            sortOrder: sOrder
          })}
    >
    </span>
  )
};

export default AgentsListSortElement;
